/* eslint-disable vue/no-use-v-if-with-v-for */

<style scoped lang='stylus'>
@import '../../assets/style/vars.styl'
.consign-recycle-order-flow
  background-color white
  height: 100vh;
  overflow: auto;
  display flex
  flex-direction column
  // 顶部step
  .flow-steps
    width 100%
    height 148px
    border-radius 0 0 26px 26px
    box-shadow 0px 4px 14px rgba(0,0,0,0.06)
    display flex
    background-color white
    z-index 10
    .through-line
      display flex
      position absolute
      top 42px
      height 2px
      left (100/6)%
      right (100/6)%
      background-color #E5E5E5
      .through-line-item
        flex 1
        height 100%
        background-color #FFF0F2
        &.actived
          background-color #FF5572
    .step-item
      position relative
      flex 1 // 务必使用等分 满足画线等分
      flex-shrink 0
      display flex
      flex-direction column
      align-items center
      justify-content center
      height 100%
      .step-icon
        height 28px
        width 28px
        background-color #FFF0F2
        border-radius 28px
      .step-name
        font-size 24px
        line-height 34px
        margin-top 30px
        color #828393
      &.actived
        .step-icon
          background-color #FF5572
          // box-shadow 0px 3px 6px rgba(0,0,0,0.11)
        .step-name
          color #2A2A30
  // 详情
  .flow-detail
    flex 1
    flex-shrink 0
    overflow auto
    background-color rgba(231, 231, 240, 0.6)
  .detail-item
    width 100%
    padding 38px 0px 0 0
    background-color white
    box-sizing border-box
    background-color white
    &:not(:last-child)
      margin-bottom 20px
    .detail-header
      line-height 48px
      font-size 34px
      color #2A2A30
      font-weight 500
      padding-left 24px
    .flow-info
      padding 24px 24px 40px 24px
      border-bottom 1px solid rgba(231, 231, 240, 0.6)
      .flow-info-item
        width 100%
        display flex
        align-items center
        &:first-child
          margin-bottom 15px
        .info-text
          flex 1
          overflow hidden
          text-overflow ellipsis
          color #828393
          font-size 28px
          line-height 40px
        .info-icon
          width 30px
          height 30px
          margin-right 19px
          &.company
            bg-image('https://oss.turingsenseai.com/1610350924625285422.png')
          &.number
            bg-image('https://oss.turingsenseai.com/1610350909887321305.png')
    // flow-records
    .flow-records
      position relative
      padding 48px 24px
      box-sizing border-box
      border-bottom 2px solid rgba(29,29,29,0.1)
      // .through-line
      //   position absolute
      //   top 52px
      //   bottom 48px
      //   left 134px
      //   width 2px
      //   background-color #E6E6E9
      .record-item
        position relative
        display flex
        overflow hidden
        &:last-child
          .icon::after
            height 0
        &:not(:last-child)
          padding-bottom 64px
        &.active
          .content, .content .content-2-main
            color #2A2A30
          .icon
            bg-image('https://oss.turingsenseai.com/1610349610894289712.png')
            &::after
              border-right 2px dashed #FF5572
        &:last-child
          margin-bottom 0
        .date-time
          position relative
          top -3px
          width 80px
          display flex
          flex-direction column
          .date
            font-size 28px
            line-height 34px
            color #2A2A30
            margin-bottom 11px
            text-align right
          .time
            font-size 20px
            line-height 24px
            color #828393
            text-align right
        .icon
          width 22px
          height 22px
          margin 0 15px
          bg-image('https://oss.turingsenseai.com/1610349620776134467.png')
          position relative
          &::after
            content ''
            display inline-block
            position absolute
            top 22px
            left 11px
            height 400px // 这根线足够长吧
            width 0px
            border-right 2px solid #E6E6E9
            box-sizing content-box
        .content
          position relative
          top -3px
          flex 1
          white-space normal
          font-size 24px
          line-height 34px
          color #828393
          padding-right 40px
          .content-2-main
            // color #2A2A30 !important
            font-size 28px !important
            margin-bottom 10px
          .content-2-text
            // color #828393 !important
            font-size 24px !important
          // 平台回收
          .recycle-content
            position relative
            color #202020
            .count-down
              display flex
              align-items center
              justify-content space-between
              position absolute
              top 1px
              right 10px
              // width 150px
              font-size 28px
              .seconds-icon
                width 34px
                height 38px
                bg-image('https://oss.turingsenseai.com/1602233223282028463.png')
                // background-size 33px 33px
                margin-right 12px
              .simple-count-down
                width 150px
            .r-title
              font-weight 600
              font-size 26px
              margin-bottom 10px
            .r-sub-title
              font-size 24px
              color #828393
              margin-bottom 28px
            .r-btns .r-btn
              width 104px
              height 50px
              font-weight 300
              background-color #FF5572
              color white
              border none
              font-size 28px
              margin-right 24px
              &:active
                opacity .9
              &.gray
                background-color transparent
                color #FF5572
                border 1px solid #FF5572
        // .white-cover-line
        //   position absolute
        //   top 32px
        //   bottom 0px
        //   left 107px
        //   width 10px
        //   background-color white
</style>
<template>
  <div class="consign-recycle-order-flow">
    <!-- 顶部物流模块进度 -->
    <div v-if="flowDataHeader && flowDataHeader.length" class="flow-steps">
      <div class="through-line">
        <!-- 第一段隐藏 -->
        <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
        <div v-if="!item.isTitleHide"
          class="through-line-item"
          v-for="(item, index) in flowDataHeader"
          v-show="index > 0"
          :key="index"
          :class="[item.itemState ? 'actived' : '']"
        ></div>
      </div>
      <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
      <div :class="['step-item', item.itemState ? 'actived' : '']" v-for="(item, index) in flowDataHeader" :key="index" v-if="!item.isTitleHide">
        <div class="step-icon"></div>
        <p class="step-name">{{item.itemTitle || '--'}}</p>
      </div>
    </div>
    <!-- 物流详情 -->
    <div class="flow-detail" v-if="flowData && flowData.length">
      <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
      <div class="detail-item" v-for="(item, index) in flowData" :key="index" v-if="item.hasDetail">
        <h3 class="detail-header">{{item.itemTitle}}</h3>
        <div class="flow-info" v-if="item.expressCompany || item.expressNumber">
          <div class="flow-info-item" v-show="item.expressCompany">
            <div class="info-icon company"></div>
            <div class="info-text">物流公司：{{item.expressCompany}}</div>
          </div>
          <div class="flow-info-item" v-show="item.expressNumber">
            <div class="info-icon number"></div>
            <div class="info-text">快递单号：{{item.expressNumber}}</div>
          </div>
        </div>
        <!-- 物流记录 -->
        <div class="flow-records" v-if="item.records && item.records.length">
          <!-- <div class="through-line"></div> -->
          <div :class="['record-item', index === 0 && rindex == 0 ? 'active' : '']" v-for="(record, rindex) in item.records" :key="rindex">
            <!-- <div v-if="rindex === item.records.length - 1" class="white-cover-line"></div> -->
            <div class="date-time">
              <span class="date">{{record.updateTime | formatDateTime('MM.DD')}}</span>
              <span class="time">{{record.updateTime | formatDateTime('HH:mm')}}</span>
            </div>
            <div class="icon"></div>
            <div class="content">
              <!-- 带主次标题文案的 -->
              <template v-if="record.comment">
                <div v-if="record.comment" class="content-2-main">{{record.content}}</div>
                <div v-if="record.content" class="content-2-text">{{record.comment}}</div>
              </template>
              <!-- 不带主次标题文案的 -->
              <template v-else-if="!record.comment">
                <div v-if="record.content" class="content-text">{{record.content}}</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import dayjs from 'dayjs'
import { consignQueryExpress, recycleQueryExpress } from '../../common/api/some'
import { getLocationQuery } from '../../common/utils'
// import testData from './test'
export default {
  name: '',
  components: {
    //
  },
  mixins: [],
  props: {
    // name: { type: Array, default: () => [] }
  },
  data: function () {
    return {
      flowDataHeader: [],
      flowData: []
    }
  },
  computed: {},
  created: function () {
    const querys = getLocationQuery() || {}
    const { orderNumber, op = '' } = querys
    this.orderNumber = orderNumber
    this.op = op
    this.getData(this.orderNumber)
  },
  mounted: function () {},
  // beforeDestroy: function() {},
  watch: {},
  methods: {
    async getData (orderNumber) {
      let api = null
      if (this.op === 'consign') api = consignQueryExpress
      if (this.op === 'recycle') api = recycleQueryExpress
      if (!api) { return Toast('参数错误') }
      const res = await api({ orderNo: orderNumber })
      // const res = testData
      if (res && res.errorCode === 0) {
        this.flowDataHeader = res.expressItems
        this.flowData = res.expressItems.filter(item => item.itemState).reverse()
      }
    },
  },
  filters: {
    formatDateTime (value, format = 'MM-DD HH:mm') {
      return dayjs(value).format(format)
    }
  }
}
</script>
